import { getPlatforms } from '@ionic/react';

export const isMobileBrowser = () => {
  return getPlatforms().includes('mobileweb');
};
